import { ListViewProvider, useListView } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { UsersListHeader } from './components/header/UsersListHeader'
import { KTCard, KTIcon } from '../../../../../_metronic/helpers'
import { UsersTable } from './table/UsersTable'
import { PatientTabs } from '../PatientPage'
import { ExactSearchInput } from '../../../../components/SearchInputs'
import { numberFormat } from '../../../../utils/Functions'
import { inputOnlyPrice } from '../../../../utils/Helper'
import { Button, Form, Row, Col, InputGroup } from 'react-bootstrap'
import { useMemo, useEffect, useState, useRef } from 'react'
import { useReactToPrint } from 'react-to-print';
import moment from 'moment'
import teethImage from '../../../../../assets/images/teeth.jpeg'
import DatePicker from '../../../../components/DatePicker'
import _ from 'lodash'
import Select from 'react-select';
import CSVExporter from '../../../../components/CSVExporter'
import api from '../../../../utils/Api'
import { useParams, useSearchParams } from 'react-router-dom'
import { useAuth } from '../../../auth/core/Auth'
import PatientTeethChart from '../../../../components/PatientTeethChart'

const states = [{
  label: 'สำเร็จ',
  value: 'completed',
  color: 'success',
  buttonVariant: 'outline-danger'
}, {
  label: 'กำลังรักษา',
  value: 'treating',
  color: 'info',
  buttonVariant: 'success'
}, {
  label: 'รอชำระเงิน',
  value: 'pending-payment',
  color: 'warning',
  buttonVariant: 'primary'
}, {
  label: 'รอคิว',
  value: 'queued',
  color: 'primary',
  buttonVariant: 'outline-info'
},]

const methods: any = [
  {
    value: 'payByCash',
    label: 'เงินสด'
  },
  {
    value: 'payByBank',
    label: 'โอนเงิน'
  },
  {
    value: 'payByCreditCard',
    label: 'บัตรเครดิต'
  },
  {
    value: 'payByWelfare',
    label: 'ประกันสังคม'
  },
  {
    value: 'payByQuotaDiscount',
    label: 'วางบิล'
  },
  {
    value: 'payByDeposit',
    label: 'เงินฝาก'
  },
]

const pageStyle = () => (`
      .pagebreak {
        display: none;
      }


      body,html {
        padding: 0!important;
        margin: 0!important;
        font-size: 15px!important;
        background-color: white!important;
        line-height: 1;
      }

      body.print-receipt {
        min-width: 0px!important;
      }

      @page {
        size: A4 portrait;
      }

      .print-container {
        padding: 5mm;
      }

      .center {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
      .with-border {
        border-top: 2px solid black;
        border-bottom: 2px solid black;
        padding: 1rem 0px;
      }
      .with-border-bottom {
        border-bottom: 2px solid black;
        padding: 0px 0px 1rem 0px;
      }
      .items-container {
        margin: 1rem 0px;
      }
      .pagebreak {
        page-break-before: always;
      }
      .item {
        display: flex;
        justify-content: space-between;
      }
      .text-center {
        text-align: center;
      }
      .my-2 {
        margin:0.75rem 0;
      }
      .mt-5 {
        margin-top: 2rem;
      }
      .px-3 {
        padding-left: 1rem;
        padding-right: 1rem;
      }
      .mt-3 {
        margin-top: 1rem;
      }
      .my-3 {
        margin-top: 1rem;
        margin-bottom: 1rem;
      }
      .mb-3 {
        margin-bottom: 1rem;
      }
      .mb-0 {
        margin-bottom: 0;
      }

      .signature-container {
        display: flex;
        justify-content: space-around;
        margin-top: 6rem;
        margin-bottom: 2rem;
      }

      .signature-line {
       border-bottom: 2px solid black;
       padding: 0px 0px 1rem 0px;
       margin-bottom: 1rem;
       width: 200px;
     }

      table {
        width: 100%;
        border-collapse: collapse;
        border-bottom: 1px solid black;
      }

      th, td {
      	border-collapse:collapse;
      	border: 1px solid black;
      	padding:0.5rem;
      }

      td {
        border-bottom: 0;
        border-top: 0;
      }
      .cross {
            position: relative;
            width: 20px;
            height: 20px;
      }

      .cross::before,
      .cross::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 3px;
        background-color: red!important;
        transform-origin: center;
      }

      .cross::before {
        transform: translate(-50%, -50%) rotate(45deg); /* Diagonal line */
      }

      .cross::after {
        transform: translate(-50%, -50%) rotate(-45deg); /* Opposite diagonal line */
      }
      .dot {
        width: 5px;
        height: 5px;
      }
      .circle {
        width: 15px;
        height: 30px;
      }
  `)

const UsersList = ({ isPatientShow }: any) => {
  const [params, setParams] = useState<any>({
    branchId: '', treatmentItemName: '', minPrice: '', maxPrice: '',
    startDate: null, endDate: null
  })
  const [data, setData] = useState<any>({})
  const { currentUser } = useAuth()
  const [treatments, setTreatments] = useState<Array<any>>([])
  const componentRef = useRef(null);
  const [promotions, setPromotions] = useState([])
  const [qs] = useSearchParams()

  const branch = data.branch?.branch || {}

  const { id } = useParams()

  useEffect(() => {
    api.request(`line-oa/patient/${id}`, (r) => {
      setData(r)
    }, { withAddress: true }, 'GET', { bearerToken: qs.get('token') || '' })
    api.request('line-oa/treatment', (r) => {
      setTreatments(r)
    }, {
      patientId: id, state: 'completed',
      types: ['product_sales', 'treatment']
    }, 'GET', { bearerToken: qs.get('token') || '' })
  }, [])

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: pageStyle() }} />

      <div style={{ width: '210mm', height: '297mm' }}>
        <div style={{ display: 'flex', marginBottom: 10 }}>
          <div style={{ flex: 1 }}>
            <h3 className="mb-0">บริษัท แอลดีซี เด็นทัล จำกัด (มหาชน)</h3>
            <p>โทร. 02-789-3050</p>
            <div>
              <p style={{ lineHeight: 1.5 }}>
                <strong>{data.branch?.hn}</strong><br />
                ชื่อ-นามสกุล : {data.prename + data.fullName}<br />
                อายุ {Math.floor(moment().diff(moment(data.dateOfBirth), 'year', true))} ปี <span style={{ marginLeft: '1rem' }}>{" "}</span> {moment(data.dateOfBirth).format('LL')}<br />
                ที่อยู่ : {data.address}<br />
                โทรฯ : {data.mobile}<br />
                โรคประจำตัว : {data.congenitalDisease || 'ไม่มีโรคประจำตัว'}<br />
                แพ้ยา : {data.drugAllergy || 'ไม่แพ้ยา'}
              </p>
            </div>
          </div>
          <div style={{ width: '45%' }}>
            <PatientTeethChart lineOa patientId={data.id} usePrimaryTeeth={data.usePrimaryTeeth} />
          </div>
        </div>

        <table style={{ width: '99.9%' }}>
          <thead>
            <tr>
              <th>วันที่</th>
              <th style={{ maxWidth: 80 }}>ตำแหน่งฟัน</th>
              <th style={{ maxWidth: 80 }}>ด้าน</th>
              <th>รายละเอียดการรักษา</th>
              <th style={{ maxWidth: 40 }}>สาขา</th>
              <th>ทันตแพทย์</th>
              <th>ค่าบริการ</th>
            </tr>
          </thead>
          <tbody>
            {treatments.map((treatment: any, index) => (
              <>
                {treatment.treatmentPaymentItems.filter(({ treatmentItem }: any) =>
                  treatmentItem.type == 'service').map((item: any) => (
                    <tr key={item.id}>
                      <td>{moment(treatment.date).format('DD/MM/YYYY')}</td>
                      <td className="text-center">{item.teeth ? item.teeth.join(',') : ''}</td>
                      <td>{item.teethSize ? item.teethSize.join(',') : ''}</td>
                      <td>{item.treatmentItem?.nameTh}</td>
                      <td className="text-center">{treatment.branch.code}</td>
                      <td style={{ width: '1%', whiteSpace: 'nowrap' }}>{treatment.doctor.fullName}</td>
                      <td style={{}}>{numberFormat(item.netPrice)}</td>
                    </tr>
                  ))
                }
              </>
            ))
            }
            <tr style={{ borderTop: '1px solid black' }}>
              <td style={{ textAlign: 'right' }} colSpan={6}>รวมเงินทั้งสิ้น</td>
              <td><strong>{numberFormat(_.sumBy(treatments, ({ treatmentPaymentItems }) => {
                return _.sumBy(treatmentPaymentItems.filter(({ treatmentItem }: any) => treatmentItem.type == 'service'), ({ netPrice }: any) => netPrice)
              }))}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}


export default UsersList
